import { Link } from "react-router-dom";

const WA_NUMBER = "5511923169450";

const getMainImage = (product: any): string => {
  if (typeof product?.image_url === "string" && product.image_url.trim()) return product.image_url;
  if (typeof product?.image === "string" && product.image.trim()) return product.image;
  if (Array.isArray(product?.images)) {
    const first = product.images.find((img: any) => typeof img === "string" && img.trim());
    if (first) return first;
  }
  if (Array.isArray(product?.colors)) {
    for (const color of product.colors) {
      if (Array.isArray(color?.images) && color.images.length > 0) {
        const first = color.images.find((img: any) => typeof img === "string" && img.trim());
        if (first) return first;
      }
      if (typeof color?.image === "string" && color.image.trim()) return color.image;
    }
  }
  return "";
};

const getProductSlug = (product: any): string => {
  if (typeof product?.slug === "string" && product.slug.trim()) return product.slug;
  if (typeof product?.id === "string" && product.id.trim()) return product.id;
  if (typeof product?.id === "number") return String(product.id);
  return "";
};

export function ProductCard({ product }: { product: any }) {
  const image = getMainImage(product);
  const slug = getProductSlug(product);
  const waMessage = encodeURIComponent(`Olá! Tenho interesse na peça: ${product?.name || "Produto"}`);
  const waHref = `https://wa.me/${WA_NUMBER}?text=${waMessage}`;

  return (
    <div className="group flex flex-col snap-start">
      {/* Image wrapper — posição relativa para o botão hover */}
      <div className="relative overflow-hidden bg-[#F5F2EC]" style={{ aspectRatio: "3/4" }}>
        <Link to={`/produto/${slug}`} className="block w-full h-full">
          {image ? (
            <img
              src={image}
              alt={product?.name || "Produto"}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
            />
          ) : (
            <div className="w-full h-full bg-[#F5F2EC] flex items-center justify-center">
              <i className="ri-image-line text-3xl text-black/20" />
            </div>
          )}

          {/* Tag badge */}
          {product?.tag && (
            <span className="absolute top-3 left-3 bg-black text-white text-[9px] tracking-[0.18em] uppercase px-2.5 py-1 z-10">
              {product.tag}
            </span>
          )}
        </Link>

        {/* Hover CTA — fora do Link */}
        <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out z-10">
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 bg-black text-white py-3.5 text-[11px] tracking-[0.18em] uppercase whitespace-nowrap cursor-pointer hover:bg-[#1a1a1a] transition-colors"
          >
            <i className="ri-whatsapp-line text-sm" />
            Comprar via WhatsApp
          </a>
        </div>
      </div>

      {/* Info */}
      <div className="pt-3 pb-1">
        <Link to={`/produto/${slug}`} className="block group/name">
          <h3 className="text-[12px] leading-[1.55] text-black/75 uppercase tracking-[0.05em] line-clamp-2 group-hover/name:text-black transition-colors">
            {product?.name || "Produto"}
          </h3>
        </Link>
      </div>
    </div>
  );
}